import categories from './categories/main'
import forms from './forms/main'
import fundingPrograms from './fundingPrograms/main'
import general from './general/main'
import loginProviders from './loginProviders/main'
import mailTemplates from './mailTemplates/main'
import organisationUsers from './organisationUsers/main'
import organisations from './organisations/main'
import processes from './processes/main'
import regions from './regions/main'
import roles from './roles/main'
import statisticProcesses from './statisticProcesses/main'
import statisticSurveyPeriods from './statisticSurveyPeriods/main'
import statisticSurveys from './statisticSurveys/main'
import statusNotifications from "./statusNotifications/main"
import statuses from './statuses/main'
import userOrganisations from './userOrganisations/main'
import users from './users/main'
import years from './years/main'

export default {
    selected: 'Ausgewählt',

    categories,
    forms,
    fundingPrograms,
    general,
    loginProviders,
    mailTemplates,
    organisationUsers,
    organisations,
    processes,
    regions,
    roles,
    statisticProcesses,
    statisticSurveyPeriods,
    statisticSurveys,
    statusNotifications,
    statuses,
    userOrganisations,
    users,
    years,
}